module.exports = __webpack_public_path__ + "static/media/Frame9.60978922.jpg";